import initMenuAndScroll from "./scrollMenu";
import howToMenuScrollbar from "./howToMenuScrollbar";
import sliceTextOnButton from "./sliceTextOnButton";

const howToContentContainer = document.querySelector(".how-to-section");

document.addEventListener("DOMContentLoaded", () => {
  if (howToContentContainer) {
    initMenuAndScroll();
    howToMenuScrollbar();
    sliceTextOnButton();
  }
});
